import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "../../PicesForPages/logoClient.jpeg";

import menuButton from "../../PicesForPages/menu.png";

function Header() {
  // Scroll to the top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll
    });
  };

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <div className="headerParent">
      <div className="HeaderTopDiv ">
        <div className="headerBox headerBoxTop">
          <span className="HeaderTopDivContent">
            <a
              href="https://maps.app.goo.gl/N39ChHDfbcTXj2Fs6"
              target="_blank"
              rel="noreferrer"
              className="HeaderTopDivContentIcon HeaderTopDivContentIcon01"
            >
              <i className="ri-map-pin-line"></i>
              <span>5714 Dorrington St, Lewis Center OH 43035</span>
            </a>
            <a
              href="mailto: contact@vidhimortgage.com"
              className="aTag_Mail HeaderTopDivContentIcon HeaderTopDivContentIcon02"
            >
              <i className="ri-mail-send-fill"></i>
              <span>contact@vidhimortgage.com</span>
            </a>
            <a
              href="tel:+1-(614) 397-1676"
              className="aTag_Tel HeaderTopDivContentIcon HeaderTopDivContentIcon03"
            >
              <i className="ri-phone-fill"></i>
              <span>(614) 397-1676</span>
            </a>
          </span>
          <span className="HeaderTopDivContent HeaderTopDivContentSM">
            <a
              href="https://www.facebook.com/VidhiMortgage/"
              className="HeaderTopDivContentIcon"
              target="_blank"
              rel="noreferrer"
            >
              <i className="ri-facebook-box-fill"></i>
            </a>

            <a
              href="https://www.instagram.com/vidhimortgage"
              className="HeaderTopDivContentIcon"
              target="_blank"
              rel="noreferrer"
            >
              <i className="ri-instagram-fill"></i>
            </a>

            <a
              href="https://www.linkedin.com/company/vidhimortgage/"
              className="HeaderTopDivContentIcon"
              target="_blank"
              rel="noreferrer"
            >
              <i className="ri-linkedin-box-fill"></i>
            </a>
            <a
              href="https://www.tiktok.com/@vidhimortgage"
              className="HeaderTopDivContentIcon"
              target="_blank"
              rel="noreferrer"
            >
              <i className="ri-tiktok-fill"></i>
            </a>
            <a
              href="https://www.youtube.com/@VidhiMortgage"
              className="HeaderTopDivContentIcon"
              target="_blank"
              rel="noreferrer"
            >
              <i className="ri-youtube-fill"></i>
            </a>
          </span>
        </div>
      </div>
      <div className="headerBox">
        <Link to="/" className="headerLogoDiv" onClick={scrollToTop}>
          <img
            fetchPriority="high"
            loading="eager"
            src={Logo}
            alt="Logo"
            className="headerLogo"
          />
        </Link>
        <div className="headerMenu">
          <ul className="headerMenuUI">
            <span className="headerMenuUI_Header">Purchase &#x025BF;</span>
            <span className="headerMenuUI_LI">
              <li>
                <Link to="/purchase" onClick={scrollToTop}>
                  Make a Purchase
                </Link>
              </li>
              <li>
                <Link to="/paper-work" onClick={scrollToTop}>
                  Necessary Paperwork
                </Link>
              </li>
              <li>
                <Link
                  to="/how-much-can-i-afford-calculator"
                  onClick={scrollToTop}
                >
                  How Much Can I Borrow?
                </Link>
              </li>
              {/* <li>How Much Can I Borrow?</li> */}
              <li>
                <Link
                  to="/what-will-my-monthly-payment-be-calculator"
                  onClick={scrollToTop}
                >
                  What’s My Monthly Installment?
                </Link>
              </li>
              <li>
                <Link to="/quick-quote" onClick={scrollToTop}>
                  Quick Quote
                </Link>
              </li>
              <li>
                <Link
                  to="https://vidhimortgage.my1003app.com/"
                  target="_blank"
                  onClick={scrollToTop}
                >
                  Apply Now
                </Link>
              </li>
              <li>
                <Link to="/fha" onClick={scrollToTop}>
                  FHA Loan Options
                </Link>
              </li>
              <li>
                <Link to="/va-loans" onClick={scrollToTop}>
                  VA Loan Programs
                </Link>
              </li>
            </span>
          </ul>
          <ul className="headerMenuUI">
            <span className="headerMenuUI_Header">Refinance &#x025BF;</span>
            <span className="headerMenuUI_LI">
              <li>
                <Link to="/refinancing" onClick={scrollToTop}>
                  Mortgage Refinance
                </Link>
              </li>
              <li>
                <Link to="/cash-out-refinance" onClick={scrollToTop}>
                  Cash Out Refinance
                </Link>
              </li>
              <li>
                <Link to="/refinance-analysis-calculator" onClick={scrollToTop}>
                  Refinance Analysis
                </Link>
              </li>
              <li>
                <Link to="/quick-quote" onClick={scrollToTop}>
                  Quick Quote
                </Link>
              </li>
              <li>
                <Link
                  to="https://vidhimortgage.my1003app.com/"
                  target="_blank"
                  onClick={scrollToTop}
                >
                  Apply Now
                </Link>
              </li>
              <li>
                <Link to="/fha-va-streamline" onClick={scrollToTop}>
                  FHA / VA Streamline Refinancing
                </Link>
              </li>
            </span>
          </ul>
          <ul className="headerMenuUI">
            <span className="headerMenuUI_Header">Tools &#x025BF;</span>
            <span className="headerMenuUI_LI">
              <li>
                <Link to="/free-reports" onClick={scrollToTop}>
                  Access Detailed Free Reports
                </Link>
              </li>
              <li>
                <Link
                  to="/how-much-can-i-afford-calculator"
                  onClick={scrollToTop}
                >
                  How Much Can I Borrow?
                </Link>
              </li>
              <li>
                <Link
                  to="/what-will-my-monthly-payment-be-calculator"
                  onClick={scrollToTop}
                >
                  What’s My Monthly Installment?
                </Link>
              </li>
              <li>
                <Link
                  to="renting-versus-buying-calculator"
                  onClick={scrollToTop}
                >
                  Rent vs. Buy Comparison Tool
                </Link>
              </li>
              <li>
                <Link to="/refinance-analysis-calculator" onClick={scrollToTop}>
                  Refinance Evaluation Tool
                </Link>
              </li>
              <li>
                <Link to="/debt-consolidation-calculator" onClick={scrollToTop}>
                  Debt Consolidation Calculator
                </Link>
              </li>
              <li>
                <Link to="/paper-work" onClick={scrollToTop}>
                  Necessary Paperwork
                </Link>
              </li>
              <li>
                <Link to="/the-loan-process" onClick={scrollToTop}>
                  Steps in the Loan Process
                </Link>
              </li>
              <li>
                <Link to="/glossary-terms" onClick={scrollToTop}>
                  Mortgage Terms Glossary
                </Link>
              </li>
            </span>
          </ul>
          <ul className="headerMenuUI">
            <span className="headerMenuUI_Header">Contact &#x025BF;</span>
            <span className="headerMenuUI_LI">
              <li>
                <Link
                  to="https://vidhimortgage.my1003app.com/"
                  target="_blank"
                  onClick={scrollToTop}
                >
                  Apply Now
                </Link>
              </li>
              <li>
                <Link to="/about-us" onClick={scrollToTop}>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/our-staff" onClick={scrollToTop}>
                  Meet Our Family
                </Link>
              </li>
              <li>
                <Link to="/contact-us" onClick={scrollToTop}>
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/licenses-disclosures" onClick={scrollToTop}>
                  Licenses & Disclosures
                </Link>
              </li>
            </span>
          </ul>
          {/* <a
            href="tel:+1-(614) 397-1676"
            className="headerMenu_Tel"
            onClick={scrollToTop}
          >
            <i class="ri-phone-fill"></i> (614) 397-1676
          </a> */}

          <Link
            to="https://vidhimortgage.my1003app.com/"
            target="_blank"
            className="headerMenuButtonLink"
            onClick={scrollToTop}
          >
            <button className="headerMenuButton" onClick={scrollToTop}>
              Apply Now
            </button>
          </Link>

          {/* Deleted-Testing code for customr details are sent Gmail through FORM  */}
          {/* <span className='headerMenuUI_Header'><Link to="/test-mail-through-form">TestMailThroughForm</Link></span> */}
        </div>
        <div className="headerMenuMobileView">
          {/* <ul className='headerMenuUI headerMenuUI00'>
                        <span className='headerMenuUI_Header'>Tools &#x025BF;</span>
                        <span className='headerMenuUI_LI headerMenuUI_LI00' >
                            <li><Link to="/free-reports">Access Detailed Free Reports</Link></li>
                            <li><Link to="/how-much-can-i-afford-calculator">How Much Can I Borrow?</Link></li>
                            <li><Link to="/what-will-my-monthly-payment-be-calculator">What’s My Monthly Installment?</Link></li>
                            <li><Link to="renting-versus-buying-calculator">Rent vs. Buy Comparison Tool</Link></li>
                            <li><Link to="/refinance-analysis-calculator">Refinance Evaluation Tool</Link></li>
                            <li><Link to="/debt-consolidation-calculator">Debt Consolidation Calculator</Link></li>
                            <li><Link to="/paper-work">Necessary Paperwork</Link></li>
                            <li><Link to="/the-loan-process">Steps in the Loan Process</Link></li>
                            <li><Link to="/glossary-terms">Mortgage Terms Glossary</Link></li>
                        </span>
                    </ul> */}
          {!menuOpen ? (
            <img
              fetchPriority="high"
              loading="eager"
              src={menuButton}
              alt="Menu Button"
              id="menubtn"
              onClick={toggleMenu}
            />
          ) : (
            <span id="closebtn" onClick={toggleMenu}>
              X
            </span>
          )}
          {menuOpen && (
            <div
              className="headerMenuMobileView headerMenuMobileViewlist"
              ref={menuRef}
            >
              <ul className="headerMenuUI">
                <span className="headerMenuUI_Header">Purchase &#x025BF;</span>
                <span className="headerMenuUI_LI">
                  <li>
                    <Link
                      to="/purchase"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Make a Purchase
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/paper-work"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Necessary Paperwork
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/how-much-can-i-afford-calculator"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      How Much Can I Borrow?
                    </Link>
                  </li>
                  {/* <li>How Much Can I Borrow?</li> */}
                  <li>
                    <Link
                      to="/what-will-my-monthly-payment-be-calculator"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      What’s My Monthly Installment?
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/quick-quote"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Quick Quote
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://vidhimortgage.my1003app.com/"
                      target="_blank"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Apply Now
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/fha"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      FHA Loan Options
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/va-loans"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      VA Loan Programs
                    </Link>
                  </li>
                </span>
              </ul>
              <ul className="headerMenuUI">
                <span className="headerMenuUI_Header">Refinance &#x025BF;</span>
                <span className="headerMenuUI_LI">
                  <li>
                    <Link
                      to="/refinancing"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Mortgage Refinance
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/cash-out-refinance"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Cash Out Refinance
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/refinance-analysis-calculator"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Refinance Analysis
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/quick-quote"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Quick Quote
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://vidhimortgage.my1003app.com/"
                      target="_blank"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Apply Now
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/fha-va-streamline"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      FHA / VA Streamline Refinancing
                    </Link>
                  </li>
                </span>
              </ul>
              <ul className="headerMenuUI">
                <span className="headerMenuUI_Header">Tools &#x025BF;</span>
                <span className="headerMenuUI_LI">
                  <li>
                    <Link
                      to="/free-reports"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Access Detailed Free Reports
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/how-much-can-i-afford-calculator"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      How Much Can I Borrow?
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/what-will-my-monthly-payment-be-calculator"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      What’s My Monthly Installment?
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="renting-versus-buying-calculator"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Rent vs. Buy Comparison Tool
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/refinance-analysis-calculator"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Refinance Evaluation Tool
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/debt-consolidation-calculator"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Debt Consolidation Calculator
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/paper-work"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Necessary Paperwork
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/the-loan-process"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Steps in the Loan Process
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/glossary-terms"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Mortgage Terms Glossary
                    </Link>
                  </li>
                </span>
              </ul>
              <ul className="headerMenuUI">
                <span className="headerMenuUI_Header">Contact &#x025BF;</span>
                <span className="headerMenuUI_LI">
                  <li>
                    <Link
                      to="https://vidhimortgage.my1003app.com/"
                      target="_blank"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Apply Now
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/about-us"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/our-staff"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Meet Our Family
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contact-us"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Contact Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/licenses-disclosures"
                      onClick={() => {
                        toggleMenu();
                        scrollToTop();
                      }}
                    >
                      Licenses & Disclosures
                    </Link>
                  </li>
                </span>
              </ul>
              {/* <a href="tel:+1-(614) 397-1676" className="headerMenu_Tel">
                <i class="ri-phone-fill"></i> (614) 397-1676
              </a> */}
              <Link
                to="https://vidhimortgage.my1003app.com/"
                target="_blank"
                className="headerMenuButtonLink"
              >
                <button
                  className="headerMenuButton"
                  onClick={() => {
                    toggleMenu();
                    scrollToTop();
                  }}
                >
                  Apply Now
                </button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;
